'use client';

import Link from 'next/link';
import * as React from 'react';

import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@/components/ui/navigation-menu';
import { cn } from '@/libs/utils';

interface Menu {
  title: string;
  href?: string;
  description?: string;
  children?: Menu[];
}

export default function PartnerHeader() {
  const components: Menu[] = [
    {
      title: 'Ways to pay',
      children: [
        {
          title: 'Credit-Buy now Pay Later',
          description: 'make a downpayment, take it home, and pay over time',
          href: 'https://motito.co/buy-now-pay-later.html',
        },
        {
          title: 'Pay4Me-Peer-to-peer financing',
          description:
            'let family and friends conveniently finance your nest purchase',
          href: 'https://motito.co/pay4me.html',
        },
        {
          title: 'KeepMyPrice',
          description:
            'Lock in your price and self-finance over 30 days to secure the best deals',
          href: 'https://motito.co/keep-my-price.html',
        },
      ],
    },
    {
      title: 'Company',
      children: [
        {
          title: 'About Us',
          href: 'https://motito.co/about-us.html',
        },
        {
          title: 'Contact Us',
          href: 'https://motito.co/contact-us.html',
        },
      ],
    },
    {
      title: 'Help Center',
      href: 'https://support.motito.co/',
    },
    {
      title: 'Blog',
      href: 'http://blog.motito.co/',
    },
  ];

  return (
    <NavigationMenu className="mx-auto w-fit">
      <NavigationMenuList className="gap-5">
        {components.map((x) =>
          x.children ? (
            <NavigationMenuItem
              className="cursor-pointer text-[#3C3C3C] underline-offset-2 transition-all hover:font-bold hover:underline"
              key={x.title}
            >
              <NavigationMenuTrigger>{x.title}</NavigationMenuTrigger>
              <NavigationMenuContent>
                <ul className="gap-2 p-4 md:w-[400px] lg:w-[500px]">
                  {x.children.map((y) => (
                    <Link
                      href={y.href ?? ''}
                      key={y.title}
                      className={cn(
                        'block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-motito-purple hover:bg-opacity-20',
                      )}
                    >
                      <p className="text-base font-medium leading-none">
                        {y.title}
                      </p>
                      <div className="" />
                      <p className="mt-3 line-clamp-2 text-sm leading-snug text-black-100">
                        {y.description}
                      </p>
                    </Link>
                  ))}
                </ul>
              </NavigationMenuContent>
            </NavigationMenuItem>
          ) : (
            <NavigationMenuItem key={x.title}>
              <Link href={x.href ?? ''} legacyBehavior passHref>
                <NavigationMenuLink className="cursor-pointer text-[#3C3C3C] underline-offset-2 transition-all hover:font-bold hover:underline">
                  {x.title}
                </NavigationMenuLink>
              </Link>
            </NavigationMenuItem>
          ),
        )}
      </NavigationMenuList>
    </NavigationMenu>
  );
}
